// must run before any module reads a cookie (PRJCBUGEN-65884)
import 'utils/cookieIdGuard';
import { createRoot } from 'react-dom/client';

// third party
import { Provider } from 'react-redux';
// project imports
import App from 'App';
import { store } from 'store';
import * as serviceWorker from 'serviceWorker';
import { ConfigProvider } from 'contexts/ConfigContext';
import { initRum } from 'rum/initRum';

// style + assets
import 'assets/scss/style.scss';

// map
import 'mapbox-gl/dist/mapbox-gl.css';

// google-fonts
import '@fontsource/outfit/100.css';
import '@fontsource/outfit/200.css';
import '@fontsource/outfit/400.css';
import '@fontsource/outfit/500.css';
import '@fontsource/outfit/600.css';
import '@fontsource/outfit/700.css';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import '@fontsource/inter/200.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';

import '@fontsource/poppins/200.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';

// src/index.js or src/App.js
import $ from 'jquery';
// Make it available globally
window.$ = $;
window.jQuery = $;
window.__INSIGHT_MUI__ = true;

try {
  if (!window.name || window.name === '') {
    window.name = 'ng-insight-mui';
  }
} catch (e) {}

// RUM after window/document and globals are ready (avoids edge cases with early module init).
initRum();

// ==============================|| REACT DOM RENDER ||============================== //

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <ConfigProvider>
      <App />
    </ConfigProvider>
  </Provider>
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

export const PageMeta = {
  pageName: "Index",
  pageObjects: []
};
